export const eslintToIgnore = 'esLintToIgnore';
export const LOAD_INFOS = 'LOAD_INFOS';
export const CHECK = 'CHECK';
export const LOGOUT = 'LOGOUT';
export const AUTHENTIFICATION_SUCCESS = 'AUTHENTIFICATION_SUCCESS';
export const AUTHENTIFICATION_FAILED = 'AUTHENTIFICATION_FAILED';



// WEBPACK FOOTER //
// ./src/store/modules/auth/types.js